export const phoneInputMask = "+______________________"
